// Masque `element` quand la page est chargée dans une iframe. Détection côté
// client uniquement : la réponse HTML de /demo/match est identique pour tous
// (cache public), donc ni variante serveur ni paramètre d'URL. Si l'accès à
// `window.top` est refusé (iframe cross-origin), on est bien dans une iframe.
export function isFramed(win = window) {
  try {
    return win.self !== win.top
  } catch {
    return true
  }
}

export function hideWhenFramed(element, win = window) {
  if (isFramed(win)) element.hidden = true
}
